import React from 'react';
import '@ant-design/v5-patch-for-react-19';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import { AmplifyProvider, Authenticator } from '@aws-amplify/ui-react';

import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <AmplifyProvider>
      <Authenticator.Provider>
        <ConfigProvider theme={{
          token: {
            fontFamily: "'Noto Sans', sans-serif"
          },
        }}>
          <App />
        </ConfigProvider>
      </Authenticator.Provider>
    </AmplifyProvider>
  </BrowserRouter>
);
